import React, { useEffect, useState } from "react";
import {
  useLogger,
  DeviceLabels,
} from "amazon-chime-sdk-component-library-react";
import { useDevices } from "../providers/DevicesProvider";
import { streamTracker } from "../utils/streamTracker";

export const DevicePermissionInitializer: React.FC = () => {
  const logger = useLogger();
  const {
    audioInputDevices,
    videoInputDevices,
    selectedAudioInputDevice,
    selectedVideoInputDevice,
    listAndSelectDevices,
    selectAudioInputDevice,
    selectVideoInputDevice,
    isDevicesLoading,
  } = useDevices();
  const [permissionsRequested, setPermissionsRequested] = useState(false);

  useEffect(() => {
    const requestPermissionsDirectly = async () => {
      if (permissionsRequested) {
        return;
      }

      try {
        setPermissionsRequested(true);
        console.log('Requesting device permissions...');

        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
          audio: true,
        });
        console.log('Permissions granted');
        
        // Track the stream for cleanup
        streamTracker.addStream(stream);
        
        stream.getTracks().forEach((track) => track.stop());
        
        // Remove from tracker after stopping
        streamTracker.removeStream(stream);

        // Wait a moment for the devices to be released, then refresh device lists
        setTimeout(async () => {
          try {
            console.log('Refreshing device lists after permission grant...');
            // Force refresh device lists
            await listAndSelectDevices(DeviceLabels.AudioAndVideo);

            // If no devices selected yet, try to select the first available devices
            if (videoInputDevices?.length && !selectedVideoInputDevice) {
              const defaultVideo = videoInputDevices[0]?.deviceId;
              if (defaultVideo) {
                await selectVideoInputDevice(defaultVideo);
                console.log('Auto-selected video device:', defaultVideo);
              }
            }

            if (audioInputDevices?.length && !selectedAudioInputDevice) {
              const defaultAudio = audioInputDevices[0]?.deviceId;
              if (defaultAudio) {
                await selectAudioInputDevice(defaultAudio);
                console.log('Auto-selected audio device:', defaultAudio);
              }
            }
          } catch (err) {
            logger.error(`Error in device initialization: ${err}`);
          }
        }, 500);

      } catch (err) {
        logger.error(`Error requesting device permissions: ${err}`);
      }
    };

    // Call immediately when component mounts
    requestPermissionsDirectly();
  }, [
    permissionsRequested,
    listAndSelectDevices,
    videoInputDevices,
    selectedVideoInputDevice,
    audioInputDevices,
    selectedAudioInputDevice,
    selectVideoInputDevice,
    selectAudioInputDevice,
    logger,
  ]);

  // This component doesn't render anything visual
  return null;
};
